<template>
  <div class="product-card">
    <div class="info-header">
      <div class="content">
        <span class="title">{{productInfo.productName}}</span>
        <span class="tag">利率{{productInfo.minYearRate}}%-{{productInfo.maxYearRate}}%</span>
        <span class="tag">期限{{productInfo.minTerms}}-{{productInfo.maxTerms}}</span>
      </div>
      <img src="../images/icon_info.png" @click="infoClick">
    </div>
    <p class="bottom-tip">为您提供本次金融服务</p>
    <div class="platform-info">
      <div class="item">
        <span class="label">平台介绍</span>
        <p>{{productInfo.platformDesc}}</p>
      </div>

      <div class="item">
        <span class="label">放款时间</span>
        <p>{{productInfo.withdrawTime}}</p>
      </div>

      <div class="item">
        <span class="label">计息标准</span>
        <!-- interestMethod  AI -->
        <p>等额本息</p>
      </div>

      <div class="item">
        <span class="label">还款规则</span>
        <p>{{productInfo.repayRule}}</p>
      </div>

      <div class="item">
        <span class="label">客服电话</span>
        <p>{{productInfo.servicePhone}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-info-card',
  props: {
    productInfo: Object
  },
  methods: {
    infoClick () {
      this.$emit('infoClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.product-card {
  padding: 40px 40px;
  background: #f7f7f7;
  width: 690px;
  height: 760px;
  margin: 0 auto 10px;
  border-radius: 20px;
  .info-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .content {
      display: flex;
      align-items: center;
      .title {
        font-size: 50px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 70px;
        white-space: nowrap;
      }
      .tag {
        font-size: 22px;
        color: #ff4633;
        border-radius: 4px;
        border: 1px solid #ff4633;
        padding: 0 10px;
        margin-left: 5px;
        white-space: nowrap;
      }
    }
    img {
      margin-left: 6px;
    }
  }
  .bottom-tip {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
  }
  .platform-info {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 20px;
    margin-top: 34px;
    height: 538px;
    padding: 30px;
    .bottom-tip {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #333333;
      }
    .item {
      display: flex;
      padding: 10px 0;
      span.label {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        width: 142px; 
        text-align: left;
        display: block;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        width: 438px;
        color: #333333;
        word-wrap: break-word;
      }
    }
  }
}
</style>